import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { publicRegistrationPath } from "../utils/publicRegistration";

// # COMPATIBILITY: shared campaign/referral links reach the same short form.
// Never reintroduce a compulsory tour or business questionnaire before signup.
export default function EmpecemosPage() {
  const { search } = useLocation();
  const entry = new URLSearchParams(search).get("entry") || "legacy-start";
  return <Navigate to={publicRegistrationPath(search, entry)} replace />;
}
